(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/overrides/sport/ice-hockey.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/overrides/sport/ice-hockey.js');
"use strict";


const newEnetpulseWidgets = svs.core.detect.feature('ft-enetpulse-new');
const _svs$components$sport = svs.components.sportinfo.common,
  MatchState = _svs$components$sport.matchState.SportinfoMatchState,
  _svs$components$sport2 = _svs$components$sport.constants,
  SportinfoPathNames = _svs$components$sport2.SportinfoPathNames,
  EnetPulseViewType = _svs$components$sport2.EnetPulseViewType,
  EnetpulseColorThemes = _svs$components$sport2.EnetpulseColorThemes,
  SvsViewType = _svs$components$sport2.SvsViewType;
const commonConfig = svs.components.sportinfo.configs.sportConfigs.commonConfig;
const _svs$components$sport3 = svs.components.sportinfo.common.constants,
  ContentProvider = _svs$components$sport3.ContentProvider,
  EnetpulseWidgets = _svs$components$sport3.EnetpulseWidgets;
const ConfigBuilder = svs.components.sportinfo.configBuilder.ConfigBuilder;
const _ConfigBuilder$addTab = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfo,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.Statistic, tab => {
    tab.set(MatchState.NotStarted, [{
      type: EnetPulseViewType.HeadToHead,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.HeadToHead,
      viewProps: {
        options: {
          lng: 'sv',
          el_limit: 5,
          sh_h2h_s_f: 'yes',
          h2h_sh_m: 'yes'
        }
      }
    }, {
      type: EnetPulseViewType.WinProbability,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.WinProbability,
      viewProps: {
        hasMultipleWidgets: true,
        options: {
          lng: 'sv'
        }
      }
    }]).setMany([MatchState.Ongoing, MatchState.Finished], [{
      type: EnetPulseViewType.MatchStatistics,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.MatchStatistics,
      viewProps: {
        options: {
          lng: 'sv'
        }
      }
    }]);
  }).addTab(SportinfoPathNames.Events, tab => {
    tab.setMany([MatchState.Ongoing, MatchState.Finished], [{
      type: EnetPulseViewType.MatchIncidents,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.MatchIncidents,
      viewProps: {
        options: {
          lng: 'sv'
        }
      }
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.Table, tab => {
    tab.setAll([{
      type: EnetPulseViewType.TournamentStandings,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.TournamentStandings,
      viewProps: {
        options: {
          lng: 'sv'
        }
      }
    }, {
      type: EnetPulseViewType.DrawStandings,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.DrawStandings,
      viewProps: {
        options: {
          lng: 'sv',
          d_sh_rn_nav_alt_a: 'yes',
          d_sh_ts: 'yes'
        }
      }
    }]);
  }).build(),
  enetpulseMenuItems = _ConfigBuilder$addTab.menuItems,
  enetpulseContent = _ConfigBuilder$addTab.content;
setGlobal('svs.components.sportinfo.configs.sportConfigs.sportTypeOverrides', {
  iceHockeyConfig: newEnetpulseWidgets ? {
    menuItems: enetpulseMenuItems,
    content: enetpulseContent,
    config: 'ice-hockey' 
  } : commonConfig
});

 })(window);